import CustomFilterText from "../unit/CustomFilterText";
import FilterDateLastYear from "../unit/FilterDateLastYear";
import FilterDecision from "../unit/FilterDecision";
import FilterEmployerCompany from "../unit/FilterEmployerCompany";
import FilterProduct from "../unit/FilterProduct";

const employersApplicationsFilters = [
  <FilterEmployerCompany
    label="Referral Source"
    source="employment_company"
    defaultValue=""
    alwaysOn
  />,

  <CustomFilterText label="App #" source="iId" defaultValue="" />,
  <CustomFilterText label="Loan #" source="sLoanNum" defaultValue="" />,
  <CustomFilterText label="User #" source="iUserId" defaultValue="" />,
  <FilterDateLastYear
    label="Application Submitted"
    source="application_submitted"
    before="and"
    variant="outlined"
  />,
  <FilterProduct label="Product" source="sProductName" before="and" />,
  <FilterDecision label="Decision" source="sReview" before="and" />,
];

export default employersApplicationsFilters;
